export interface Testimonial {
  name: string
  initials: string
  role: string
  location: string
  text: string
}

export const shortTestimonials: Testimonial[] = [
  {
    name: 'Marcus Reed',
    initials: 'MR',
    role: 'Olympic Weightlifting Coach',
    location: 'Austin, Texas, USA',
    text: 'Before using Olympic Weightlifting Coach Ready, I was spending hours every week planning sessions from scratch. Now I have complete ready-to-coach lessons, visual progressions, and clear technical sequences for Snatch and Clean & Jerk. It saves me an incredible amount of time and gives my athletes a much more structured training experience.',
  },
  {
    name: 'Sophie Laurent',
    initials: 'SL',
    role: 'Weightlifting Coach',
    location: 'Lyon, France',
    text: 'What I value most is how visual the system is. The technical breakdowns, lift sequences, and correction-based explanations make it much easier to teach complex movements with confidence. My athletes understand positions, timing, and movement quality much faster because everything is presented in a clear and coach-friendly way.',
  },
  {
    name: 'Daniel Foster',
    initials: 'DF',
    role: 'Strength & Weightlifting Coach',
    location: 'Manchester, UK',
    text: 'This is much more than a few lesson ideas. Olympic Weightlifting Coach Ready gave me a full coaching system with ready sessions, visual drills, and highly useful bonus guides. It helped me coach more confidently, stay organized, and deliver better sessions without wasting time searching for extra material.',
  },
]
